<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <mask
        id="randomIcon"
        width="24"
        height="24"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style="mask-type: alpha"
      >
        <path fill="inherit" stroke="none" d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#randomIcon)">
        <path
          fill="inherit"
          stroke="none"
          d="M15.85 17.15q.54 0 .92-.38.39-.38.38-.92 0-.55-.38-.93a1.3 1.3 0 0 0-.92-.38q-.55 0-.93.38-.38.37-.38.93 0 .54.38.92.37.39.93.38M12 13.31q.55 0 .93-.38t.38-.93-.38-.93a1.3 1.3 0 0 0-.93-.38q-.55 0-.93.38t-.38.93.38.93.93.38M8.15 9.46q.55 0 .93-.38.38-.37.38-.93 0-.54-.38-.92a1.3 1.3 0 0 0-.93-.38q-.54 0-.92.38t-.38.92.38.93.92.38M5.62 20q-.7 0-1.16-.46T4 18.38V5.62q0-.7.46-1.16T5.62 4h12.76q.7 0 1.16.46T20 5.62v12.76q0 .7-.46 1.16t-1.16.46zm0-1h12.76q.24 0 .43-.2.2-.18.19-.42V5.62q0-.24-.2-.43a.6.6 0 0 0-.42-.19H5.62q-.24 0-.43.2a.6.6 0 0 0-.19.42v12.76q0 .24.2.43.18.2.42.19"
        />
      </g>
    </svg>
  </span>
</template>
